import Base from './base'
import Request from '@utils/request'
import { toQueryString, newFormData } from '@utils'

class Project extends Base {
  async show (id, params = {}) {
    const url = `/api/projects/${id}?${toQueryString(params)}`
    const response = await Request.get(url)

    return response
  }

  async store (payload) {
    const data = newFormData(payload)

    const response = await Request.custom({
      url: '/api/projects',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    })

    return response
  }

  async update (id, payload) {
    const data = newFormData(payload)

    const response = await Request.custom({
      url: `/api/projects/${id}`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    })

    return response
  }

  async delete (id) {
    const response = await Request.delete(`/api/projects/${id}`)

    return response
  }

  async complete (id, payload) {
    const response = await Request.put(`/api/projects/${id}/complete`, payload)

    return response
  }

  async adminReview (id, payload) {
    const response = await Request.put(`/api/admin/projects/${id}/review`, payload)

    return response
  }
}

export default new Project()
